import {createFetchAllSlice} from "../genericCrudSlice";
import {getMovementsApi} from "../../api/entities/movements";

export const fetchMovementsSlice = createFetchAllSlice('movements', getMovementsApi);
export const {setFilter: setMovementsFilter} = fetchMovementsSlice.actions;
export const {fetchAllEntities: fetchMovements} = fetchMovementsSlice;
export default fetchMovementsSlice.reducer;
